/** Menu flag: user is on a helpdesk support level or has a legacy IT/helpdesk role. */
export const HELPDESK_SUPPORT_MENU_FLAG = { requiredHelpdeskSupport: true };

/** Legacy app roles (optional; support-level membership is the primary gate). */
export const HELPDESK_SUPPORT_ROLES = [
  'admin',
  'it_communication_officer',
  'mel_manager',
  'helpdesk_manager',
  'helpdesk_agent',
];

export const HELPDESK_QUEUES = {
  'my-requests': {
    id: 'my-requests',
    title: 'My requests',
    description: 'Tickets you have submitted and their status.',
    scope: 'my-requests',
  },
  all: {
    id: 'all',
    title: 'All tickets',
    description: 'Full ticket queue for support staff — search, filter, and manage every ticket.',
    supportOnly: true,
  },
  unassigned: {
    id: 'unassigned',
    title: 'Unassigned queue',
    description: 'Open tickets waiting for an agent assignment.',
    supportOnly: true,
    unassigned: true,
  },
  'my-assignments': {
    id: 'my-assignments',
    title: 'Assigned to me',
    description: 'Tickets currently assigned to you.',
    supportOnly: true,
    scope: 'my-assignments',
  },
  overdue: {
    id: 'overdue',
    title: 'SLA overdue',
    description: 'Open tickets past their resolution SLA deadline.',
    supportOnly: true,
    slaOverdue: true,
  },
};
